export const RoleType = Object.freeze({
  ROLE_ANONYMOUS: 'ROLE_ANONYMOUS' as string,
  ROLE_MEMBER: 'ROLE_MEMBER' as string,
  ROLE_ADMIN: 'ROLE_ADMIN' as string,
  ROLE_ASSET: 'ROLE_ASSET' as string,
});
